import React, { memo } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import styles from "./PlatformSwitcher.module.scss";

interface PlatformSwitcherTriggerProps {
  onClick: () => void;
}

const PlatformSwitcherTrigger: React.FC<PlatformSwitcherTriggerProps> = ({
  onClick,
}) => (
  <Tooltip title="Show platform switcher">
    <button
      type="button"
      className={styles.navbarInfoTrigger}
      onClick={onClick}
      aria-label="Show platform switcher"
    >
      <InfoOutlinedIcon className={styles.navbarInfoIcon} />
    </button>
  </Tooltip>
);

export default memo(PlatformSwitcherTrigger);
